var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17.028","height":"17.039","viewBox":"0 0 17.028 17.039"}},[_c('path',{attrs:{"id":"Path_679","data-name":"Path 679","d":_vm.d,"transform":"translate(-4174.983 -9010.053)","fill":"#7c7c7c"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }